<template>
    <div>
        <h1 class="mb-4">Logs</h1>
        <el-table :data="logs" border stripe>
            <el-table-column prop="time" label="Timestamp" width="200">
                <template #default="scope">
                    {{ formatDate(scope.row.timestamp, 'DD MMM, hh:mm:ss A') }}
                </template>
            </el-table-column>
            <el-table-column prop="message" label="Message">
                <template #default="scope">
                    <div :class="{'text-red-500': scope.row.type == 'error'}">
                        <span :class="{'el-icon-error': scope.row.type == 'error'}"></span>
                        <span :class="{'el-icon-info': scope.row.type == 'log'}"></span>
                        {{ scope.row.message }}
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
const {useExtension} = useHelpers()
const {formatDate} = useFilters()

export default {
    name: 'Logs',
    data() {
        return {
            logs: []
        }
    },
    async mounted() {
        let {result} = await useExtension('getCapturedLogs', [], 'sandbox')
        this.logs = result
        console.log(result)
    },
    methods: {
        formatDate
    }
}
</script>

<style scoped>
/* Your component styles here */
</style>